namespace GeniuzPOS.InitialData {
    export interface PsPosTouchPanelTypeRow {
        Id?: number;
        TouchPanelType?: string;
        POSScreenType?: string;
        TouchPanelDesc?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsPosTouchPanelTypeRow {
        export const idProperty = 'TouchPanelType';
        export const nameProperty = 'TouchPanelDesc';
        export const localTextPrefix = 'InitialData.PsPosTouchPanelType';
        export const lookupKey = 'InitialData.PsPosTouchPanelType';

        export function getLookup(): Q.Lookup<PsPosTouchPanelTypeRow> {
            return Q.getLookup<PsPosTouchPanelTypeRow>('InitialData.PsPosTouchPanelType');
        }
        export const deletePermission = '';
        export const insertPermission = '';
        export const readPermission = '';
        export const updatePermission = '';

        export declare const enum Fields {
            Id = "Id",
            TouchPanelType = "TouchPanelType",
            POSScreenType = "POSScreenType",
            TouchPanelDesc = "TouchPanelDesc",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
